module.exports = __webpack_public_path__ + "static/hiw-img-c09cdef0b4ff619080ac1b0545ea9755.jpg";